import $ from "jquery";
import axios from "axios";

$(function () {
    $(document).on('click', '.input-qty-value .plus', function () {
        $(this).parent().addClass('use');
        const input = $(this).siblings('input');
        let newValue = parseInt(input.val())
        if (newValue < 90) {
            input.val(++newValue);
        } else {
            input.val(90);
        }

        updateFinalPrice($(this));
    })

    $(document).on('click', '.input-qty-value .minus', function () {
        $(this).parent().addClass('use');
        const input = $(this).siblings('input');
        let newValue = parseInt(input.val());
        if (newValue > 0) {
            input.val(--newValue);
        }

        if (newValue <= 0) {
            input.val(0);
            $(this).parent().removeClass('use');
        }

        updateFinalPrice($(this));
    });

    $(document).on('click', '.product-qty-value .plus', function () {
        const input = $(this).siblings('input');
        let newValue = input.val();
        if (newValue < 90) {
            input.val(++newValue);
        }

        updateFinalPrice($(this));
    });

    $(document).on('click', '.product-qty-value .minus', function () {
        const input = $(this).siblings('input');
        let newValue = input.val();
        if (newValue > 1) {
            input.val(--newValue);
        }

        updateFinalPrice($(this));
    });

    $(document).on('change', '.js-combo-product', function () {
        const form = $(this).closest('form');

        const comboIsChecked = $(this).is(":checked");
        const comboContainer = form.find('.combo-container');
        const priceContainer = form.find('.js-product_qty');
        if (comboIsChecked) {
            priceContainer.data('price', comboContainer.data('combo-price'));
            comboContainer.slideDown(200, function () {
                $(this).addClass('show');
            })

            syncButtonValidate(form);
        } else {
            priceContainer.data('price', comboContainer.data('price'));
            comboContainer.slideUp(200, function () {
                $(this).removeClass('show');
            })

            form.find('.big-add-to-cart').attr('disabled', false);
        }

        updateFinalPrice($(this));
    });

    $(document).on('change', '.js-combo-input', function () {
        $(this).closest('.radio-groups').addClass('checked');
        syncButtonValidate($(this).closest('form'));
    });

    $(this).on('change', '.js-input-modification', function () {
        $(this).closest('.radio-groups').addClass('checked');
    })

    $(document).on('click', '.info-energetics, .js-tooltip-box', function () {
        const ref = $(this);

        $('.js-tooltip-box.show').removeClass('show');

        if (!$(ref).hasClass('show')) {
            $(ref).addClass('show frozen');
            setTimeout(function () {
                $(ref).removeClass('frozen');
            }, 300);
        } else {
            $(ref).removeClass('show');
        }
    });

    $(document).on('click', 'body', function (event) {
        if (!$(event.target).closest('.info-energetics').length) {
            $('.info-energetics.show').removeClass('show');
        }

        if (!$(event.target).closest('.js-tooltip-box').length) {
            if (!$('.js-tooltip-box.frozen').length) {
                $('.js-tooltip-box.show').removeClass('show');
            }
        }
    });

    function syncButtonValidate(form) {
        let disableBtn = false;

        form.find('.combo-container .modification-container').each(function (item) {
            if (!$(this).find('.js-combo-input:checked').length) {
                disableBtn = true;
            }
        })

        form.find('.big-add-to-cart').attr('disabled', disableBtn);
    }

    function updateFinalPrice(th) {
        const form = th.closest('form');
        const productQty = form.find('.js-product_qty');
        const toppings = form.find('.js-topping');
        const productData = productQty.data();
        const productName = form.find('.info h1').text();
        const productId = form.find('input[name=product_id]').val();

        let productPrice = 0;

        if (productData.price !== 'free') {
            productPrice = parseFloat(productData.price);
        }

        let toppingsPrice = 0;
        toppings.each(function () {
            if ($(this).val() > 0) {
                let qty = parseInt($(this).val());
                if (parseInt($(this).data().free) === 0 && qty) {
                    toppingsPrice += parseFloat($(this).data().price) * qty;
                }
            }
        });

        let totalPrice = 0;
        if (toppingsPrice) {
            totalPrice = (productPrice * parseInt(productQty.val())) + (parseInt(productQty.val()) * toppingsPrice);
        } else {
            totalPrice = (productPrice * parseInt(productQty.val()));
        }

        form.find('.cart-product-total .price').html(totalPrice);
    }

    const $body = $('body');

    $body.on('click', '.js-show-details', function (e) {
        e.preventDefault();

        const data = {product: $(this).data('toppings'), name: $(this).data('name')};

        axios.post('/get-details', data)
            .then(function (response) {
                console.log('data toppings', response.data);
                $('#detailsModal').html(response.data).css('display', 'flex');
            })
            .catch(function (error) {
                console.log('data not found');
                $('#detailsModal').html('')
            });

        $('body').css('overflow-y', 'hidden');
    });

    $body.on('click', '.js-close-details', function (e) {
        e.preventDefault();
        $('#detailsModal').html('').css('display', 'none');
        $('.js-show-details').removeClass('is-toggle');

        $('body').css('overflow-y', 'auto');
    });

    $body.on('click', '.js-handle-count', function (e) {
        e.preventDefault();
        handleCount(this)
    });

    $body.on('change', '.js-product-qty', function (e) {
        e.preventDefault();
        handleCount(this, true)
    });

    $body.on('click', '.js-remove-item', function (e) {
        e.preventDefault();

        const productCard = this.closest('.cart-product');
        const id = parseInt(productCard.dataset.id);

        axios.post('/sync-remove', {
            product: {
                id: id
            }
        })
            .then(function (response) {

                productCard.remove();
                updateCartPrice(true);

            })
            .catch(function (error) {

                console.log('Error sync!', error);
            });

    })

    function handleCount(self, input = false) {
        const productCard = self.closest('.cart-product');
        const productPrice = productCard.querySelector('.cart-product-price');
        const id = parseInt(productCard.dataset.id);

        let price = parseFloat(productCard.dataset.price);
        let newQuantity = parseInt(productCard.dataset.quantity);
        const unitPrice = parseInt(price / newQuantity);

        if (input) {
            if (self.value <= 0 || isNaN(self.value)) {
                newQuantity = 1;
                $(productCard).find('.cart-product-qty').val(newQuantity);

            } else {
                newQuantity = self.value;
            }
        } else {
            if (self.dataset.dir > 0 && newQuantity > 0) {
                newQuantity += 1;
            } else if (newQuantity > 1) {
                newQuantity -= 1;
            }
            $(productCard).find('.cart-product-qty').val(newQuantity);
        }

        productCard.dataset.quantity = newQuantity;
        productCard.dataset.price = newQuantity * unitPrice;
        $(productCard).find('.js-cart-product-price').html(newQuantity * unitPrice);
        productPrice.textContent = newQuantity * unitPrice;

        updateCartPrice(false, id, newQuantity);
    }

    function updateCartPrice(remove = false, id, qty) {
        const totalPrice = Array.from(document.querySelectorAll('.cart-product'))
            .reduce(function (total, node) {
                return total + parseFloat(node.dataset.price);
            }, 0)
        console.log(totalPrice)
        if (totalPrice === 0) {
            $("order-2").addClass('disabled');
            document.location.reload();
        }

        let tot = $('.js-total-price');
        let cartTotal = $('.js-cart-total');
        let isDeliveryFree = $('.js-free-delivery');
        let cart = $('#card');
        let deliveryPrice = parseFloat(cart.data('delivery'));
        const freeDeliveryPrice = parseFloat(cart.data('free-delivery-price'));
        const deliveryType = cart.data('delivery-type');

        const remainingTxt = cart.data('remaining-delivery');
        const includeTxt = cart.data('include-delivery');
        const currency = cart.data('currency');
        const lowCurrency = cart.data('low-currency');
        const free = cart.data('free');

        if (deliveryType === 'pickup') {
            deliveryPrice = 0;
        } else {
            if (totalPrice >= freeDeliveryPrice) {
                deliveryPrice = 0;
                $('.including-delivery').html('');
                $('.remaining-delivery').html('');
            } else {
                let remaining = freeDeliveryPrice - totalPrice;

                $('.including-delivery').html(includeTxt);
                $('.remaining-delivery').html(remainingTxt.replace("{xxxx}", remaining));
            }
        }

        tot.html(totalPrice + deliveryPrice);
        cartTotal.html(totalPrice + ' ' + currency);

        let isFreeDelivery = (deliveryPrice > 0) ? deliveryPrice + ' ' + lowCurrency : free;

        isDeliveryFree.html(isFreeDelivery);

        if (!remove) sync(id, qty);
    }

    function sync(id, qty) {
        axios.post('/sync', {
            product: {
                id: id, quantity: qty
            }
        }).catch(function (error) {
            console.log('Error sync!', error);
        });
    }

    saveStatesOrderForm();
    updateOrderConfirmedStatus();


    const paymentTypeInputs = document.getElementsByName('payment_type');
    const paymentButton = document.getElementById('submit-command');
    for (let i = 0; i < paymentTypeInputs.length; i++) {
        paymentTypeInputs[i].addEventListener('change', function () {
            if (!paymentButton.classList.contains('f-disabled')) {
                paymentButton.removeAttribute('disabled');
            }
        });
    }
});

function updateOrderConfirmedStatus() {
    $('.status-container').each(function (el) {
        // const el = $(this);
        const that = $(this);
        const url = that.attr('data-url-update');

        if (!url) {
            return;
        }

        setInterval(function () {
            axios.get(url, {}).then(function (response) {
                const labelContainer = that.siblings('.description-container');

                if (that.hasClass('without-st')) {
                    $('#group_' + response.data.uuid).html(response.data.form);
                    labelContainer.find('.label-title').replaceWith('<p class="label-title">' + response.data.apiStatusLabel.label + '</p>');
                    labelContainer.find('.label-desc').replaceWith('<span class="label-desc">' + response.data.apiStatusLabel.desc + '</span>');
                } else {
                    $('#group_' + response.data.uuid)
                        .closest('.close-order-status')
                        .replaceWith(response.data.form)
                }
            }).catch(function (error) {
                console.log('Error sync!', error);
            });
        }, 10000)
    })
}

const debounce = (func, delay) => {
    let debounceTimer;

    return function () {
        const context = this
        const args = arguments
        clearTimeout(debounceTimer)
        debounceTimer = setTimeout(() => func.apply(context, args), delay)
    }
}

function saveStatesOrderForm() {
    if (!$('#delivery-form').length) {
        // console.log('test')
        return;
    }

    const form = $('#delivery-form');
    const debouncedHandle = debounce(serializeForm, 300);
    form.find('input, textarea').on('keyup change', function () {
        debouncedHandle(form);
    })
}

function serializeForm(form) {
    console.log(form.serialize());
}



// WEBPACK FOOTER //
// ./resources/assets/js/cart.js